import Environment from './Environment'

export default class TlsCertificate {

  constructor(cert = {}) {
    this.id = cert.id || null
    this.issuer = cert.issuer || ''
    this.protocol = cert.protocol || ''
    this.cipher = cert.cipher || ''
    this.cipher_strength_score = cert.cipher_strength_score || null
    this.http_clock_skew = cert.http_clock_skew || null
    this.cert_expiration = cert.cert_expiration || null
    this.key_exchange_score = cert.key_exchange_score || null
    this.final_score = cert.final_score || null
    this.overall_grade = cert.overall_grade || null
    this.updated_at = cert.updated_at || null
    this.created_at = cert.created_at || null
    this.environment_id = cert.environment_id || null
    this.environment = new Environment(cert.environment) || new Environment()
    this.findings = cert.findings || []
  }

  mutations() {
    return {
      setCertificate: (state, cert) => state.cert = new TlsCertificate(cert),
      clearEnvironment: (state) => state.cert = new TlsCertificate(),
    }
  }
}